import { ArticleUiIcon } from '@/components/icons/article-ui-icon'

interface LogoSvgProps {
  className?: string
}

export const LogoSvg = ({ className }: LogoSvgProps) => (
  <ArticleUiIcon id="score-logo" viewBox="0 0 20 28" fill="none" className={className} />
)
